import { connect } from 'react-redux';
import { eventActions } from '../../actions';
import EventsList from '../../components/admin/EventsList';

function mapStateToProps(state, ownProps) {
  return {
    selectedEvent: state.selectedEvent.selectedEvent,
    selectedUser: state.selectedEvent.selectedUser,
    isLoading: state.events.isLoading
  }
}

export default connect(mapStateToProps)(EventsList)
